var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.128,
    height: 32.164,
    viewBox: "0 0 32.128 32.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "move",
    transform: "translate(-0.28 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6158",
    "data-name": "Group 6158",
    transform: "translate(11.612 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6157",
    "data-name": "Group 6157",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6828",
    "data-name": "Path 6828",
    d: "M182.826,4.117,178.973.264a.941.941,0,0,0-1.307,0l-3.774,3.774a.907.907,0,0,0,0,1.282l.487.487a.926.926,0,0,0,1.278,0L177.1,4.358V9.679a.238.238,0,0,0,.012.045.908.908,0,0,0,.9.831h.688a.91.91,0,0,0,.911-.906V4.437l1.445,1.448a.905.905,0,0,0,1.28,0l.486-.486A.907.907,0,0,0,182.826,4.117Z",
    transform: "translate(-173.627 0)",
    fill: "#efefef"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6160",
    "data-name": "Group 6160",
    transform: "translate(11.612 21.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6159",
    "data-name": "Group 6159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6829",
    "data-name": "Path 6829",
    d: "M182.821,335.725l-.486-.487a.926.926,0,0,0-1.279,0l-1.445,1.448v-5.191a.928.928,0,0,0-.91-.926h-.688a.916.916,0,0,0-.9.84.361.361,0,0,0-.012.055v5.3l-1.445-1.448a.928.928,0,0,0-1.28,0l-.486.487a.908.908,0,0,0,0,1.282l3.774,3.774a.891.891,0,0,0,.632.264h.034a.9.9,0,0,0,.64-.264l3.853-3.853A.907.907,0,0,0,182.821,335.725Z",
    transform: "translate(-173.622 -330.569)",
    fill: "#efefef"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6162",
    "data-name": "Group 6162",
    transform: "translate(0.28 11.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6161",
    "data-name": "Group 6161",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6830",
    "data-name": "Path 6830",
    d: "M9.888,177.227H4.717l1.448-1.44a.9.9,0,0,0,0-1.275l-.487-.486a.907.907,0,0,0-1.282,0L.544,177.879a.942.942,0,0,0,0,1.307l3.774,3.774a.907.907,0,0,0,1.282,0l.486-.486a.91.91,0,0,0,0-1.284l-1.448-1.45H9.916a.376.376,0,0,0,.057-.007.913.913,0,0,0,.843-.9v-.689A.938.938,0,0,0,9.888,177.227Z",
    transform: "translate(-0.28 -173.761)",
    fill: "#efefef"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6164",
    "data-name": "Group 6164",
    transform: "translate(21.872 11.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6163",
    "data-name": "Group 6163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6831",
    "data-name": "Path 6831",
    d: "M340.843,177.891l-3.853-3.853a.907.907,0,0,0-1.282,0l-.486.487a.9.9,0,0,0-.265.64.88.88,0,0,0,.265.633l1.448,1.44h-5.2a.915.915,0,0,0-.9.921v.689a.9.9,0,0,0,.828.9.2.2,0,0,0,.042.007h5.307L335.3,181.2a.911.911,0,0,0,0,1.283l.487.487a.906.906,0,0,0,1.281,0l3.774-3.774a.941.941,0,0,0,0-1.306Z",
    transform: "translate(-330.571 -173.773)",
    fill: "#efefef"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6166",
    "data-name": "Group 6166",
    transform: "translate(13.83 13.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6165",
    "data-name": "Group 6165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6832",
    "data-name": "Path 6832",
    d: "M210.069,207.541a2.514,2.514,0,1,0,2.514,2.514A2.517,2.517,0,0,0,210.069,207.541Z",
    transform: "translate(-207.555 -207.541)",
    fill: "#efefef"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.145a554b45ebf072577a9676659892ff.svg";
export { ForwardRef as ReactComponent };